"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
function LeaveGroupDialog({ isOpen, groupName, onLeave, onCancel, }) {
    return ((0, jsx_runtime_1.jsx)(ui_1.Dialog, { isOpen: isOpen, onClose: onCancel, title: (0, i18n_1.Localized)(i18n_1.Strings.settings.sharing.leaveGroup), buttons: [
            (0, jsx_runtime_1.jsx)(ui_1.PrimaryButton, { onClick: onLeave, size: ui_1.ButtonSize.Small, children: (0, i18n_1.Localized)(i18n_1.Strings.settings.sharing.leave) }, "leave"),
            (0, jsx_runtime_1.jsx)(ui_1.FlatButton, { onClick: onCancel, size: ui_1.ButtonSize.Small, children: (0, i18n_1.Localized)(i18n_1.Strings.common.cancel) }, "cancel"),
        ], "data-e2e": 'LeaveGroupDialog_Dialog', children: (0, jsx_runtime_1.jsx)(DialogContent, { "data-e2e": 'LeaveGroupDialog_DialogContent', children: (0, i18n_1.Localized)(i18n_1.Strings.settings.sharing.leaveConfirm, { group: groupName }) }) }));
}
const DialogContent = styled_components_1.default.div `
  margin: 0 0 40px 0;

  color: ${props => props.theme.white};

  font-size: 16px;
`;
exports.default = LeaveGroupDialog;
